<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">会员卡售卖</div>

    <div class="search-wrapper">
      <el-form :inline="true" v-model="paramData">
        <el-form-item label="状态">
          <el-select placeholder="请选择状态" v-model="paramData.status">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已发布" :value="1"></el-option>
            <el-option label="未发布" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="margin-left-10" type="primary" @click="queryList"
        >搜索</el-button
      >
      <el-button @click="clickReset">重置</el-button>
    </div>

    <div class="action-wrapper">
      <!-- 卡片类型切换：1=售卖卡 2=赠送卡 3=预售卡（对应接口必传的 type） -->
      <el-button-group class="card-type-group">
        <el-button
          :type="activeTab === '1' ? 'primary' : ''"
          @click="handleTabChange('1')"
          >售卖卡</el-button
        >
        <el-button
          :type="activeTab === '2' ? 'primary' : ''"
          @click="handleTabChange('2')"
          >赠送卡</el-button
        >
        <el-button
          :type="activeTab === '3' ? 'primary' : ''"
          @click="handleTabChange('3')"
          >预售卡</el-button
        >
      </el-button-group>
      <el-button @click="clickExport">导出售卖/预售卡销售明细</el-button>
      <el-button type="primary" @click="clickAddition">新增</el-button>
    </div>

    <div class="content-wrapper">
      <el-table :data="listData">
        <el-table-column align="center" label="ID" prop="id"></el-table-column>
        <el-table-column
          align="center"
          label="名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          align="center"
          label="特权角色"
          prop="privilegeName"
        ></el-table-column>
        <el-table-column align="center" min-width="180" label="会员时长">
          <template scope="{ row }">
            <span v-if="row.type === 3"
              >{{ dayjs(row.effectiveStartTime).format("YYYY-MM-DD") }} 至
              {{ dayjs(row.effectiveEndTime).format("YYYY-MM-DD") }}</span
            >
            <span v-else>{{ row.duration + "天" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="售卖价格">
          <template scope="{ row }">{{ (row.price || 0) / 100 }}</template>
        </el-table-column>
        <el-table-column align="center" label="赠送体验卡">
          <template scope="{ row }">
            <div v-if="row.cardConfig" v-for="(item, index) in row.cardConfig">
              {{ item.name + "*" + item.num }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="售卖图片" min-width="100">
          <template scope="{ row }">
            <div class="flex-row-center margin-bottom-10">
              <img class="table-img" :src="row.url" alt="" />
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          label="已售张数"
          prop="usedQuantity"
        ></el-table-column>
        <el-table-column align="center" label="状态">
          <template scope="{ row }">{{
            row.status == 1 ? "已发布" : "已撤销"
          }}</template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220" fixed="right">
          <template scope="{ row }">
            <el-button
              v-if="row.status == 2"
              type="text"
              @click="clickPublish(row)"
              >发布</el-button
            >
            <!-- <el-button type="text" style="color: red" @click="clickDelete(row)">删除</el-button> -->
            <!-- 已撤销状态：新增编辑入口（编辑仅保存，不改状态；点「发布」才变为已发布） -->
            <el-button
              v-if="row.status == 2"
              type="text"
              @click="clickEdit(row)"
              >编辑</el-button
            >
            <el-button
              v-else
              type="text"
              style="color: red"
              @click="clickRevoke(row)"
              >撤销发布</el-button
            >

            <el-button
              v-if="row.type != 2"
              type="text"
              @click="routeMemberPromotion(row)"
              >查看促销</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        v-show="total > 0"
        layout="total, prev, pager, next, jumper"
        :current-page="paramData.pageNum"
        :page-size="paramData.pageSize"
        :total="total"
        @current-change="changeCurrentPage"
      >
      </el-pagination>
    </div>

    <!-- 导出卡销售明细（售卖卡 / 预售卡） -->
    <el-dialog
      title="导出卡销售明细"
      :visible.sync="exportDialog.visible"
      :modal-append-to-body="false"
      width="380px"
      size="mini"
    >
      <el-form label-width="100px" label-position="left">
        <el-form-item label="销售时间" required>
          <el-date-picker
            v-model="exportForm.timeRange"
            type="daterange"
            range-separator="至"
            placeholder="开始时间至结束时间"
            style="width: 100%"
          ></el-date-picker>
          <div class="tip-text">
            必填；结束时间须 ≤ 当前系统时间，开始时间须早于结束时间，跨度最多
            365 天
          </div>
        </el-form-item>
        <el-form-item label="会员卡状态">
          <el-radio-group
            v-model="exportForm.status"
            @change="handleExportStatusChange"
          >
            <el-radio :label="1">已发布</el-radio>
            <el-radio :label="2">已撤销</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员卡类型">
          <el-checkbox-group
            v-model="exportForm.types"
            @change="handleExportTypeChange"
          >
            <el-checkbox :label="1">售卖卡</el-checkbox>
            <el-checkbox :label="3">预售卡</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择售卖卡">
          <el-select
            v-model="exportForm.privilegeConfigIds"
            multiple
            placeholder="默认全部"
            style="width: 100%"
          >
            <el-option
              v-for="card in sellOptions"
              :key="card.id"
              :label="`${card.name}（ID:${card.id}）`"
              :value="card.id"
            ></el-option>
          </el-select>
          <div class="tip-text">
            默认全部，支持多选；选项范围为上方所选「会员卡状态」「会员卡类型」对应的会员卡
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div class="dialog-footer">
          <el-button @click="exportDialog.visible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="exportDialog.loading"
            @click="confirmExport"
            >导出</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      // 卡片类型：1=售卖卡 2=赠送卡 3=预售卡（对应接口必传的 type）
      activeTab: "1",
      paramData: {
        status: -1, // 状态（-1全部 1已发布 2撤销发布）
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      listData: [],
      // 导出卡销售明细弹窗
      exportDialog: {
        visible: false,
        loading: false,
      },
      exportForm: {
        timeRange: [],
        status: 1, // 单选，默认「已发布」；1-已发布 2-已撤销（下发时包成 statuses 数组）
        types: [1, 3], // 会员卡类型多选，默认售卖卡 + 预售卡（1售卖卡 3预售卡）
        privilegeConfigIds: [], // 空=全部
      },
      sellOptions: [], // 会员卡选项（按导出弹窗所选状态 + 类型查询）
    };
  },

  mounted() {
    this.queryList();
  },

  methods: {
    dayjs,
    // 查询列表
    queryList() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/privilegeConfig/list",
        method: "GET",
        params: { ...this.paramData, type: Number(this.activeTab) },
      })
        .then((res) => {
          this.total = res.data.data.total || 0;
          this.listData = res.data.data.models || [];
        })
        .catch((err) => {
          this.total = 0;
          this.listData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新状态（发布或撤销）
    updateStatus(params) {
      let message =
        "确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容";
      let title = "发布";
      if (params.status === 2) {
        message =
          "确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容";
        title = "撤销";
      }
      this.$confirm(message, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http({
            url: this.$util.domain + "/adminapi/privilegeConfig/publish",
            method: "POST",
            body: JSON.stringify({ ...params }),
          })
            .then((res) => {
              if (res.body.error === 10000) {
                this.queryList();
              } else {
                this.$util.errorMsg(res.body.message || "请联系管理员");
              }
            })
            .catch((err) => {
              this.$util.errorMsg(err.message);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    // 发送删除
    sendDelete(params) {
      this.$confirm("确定要删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http({
            url: this.$util.domain + "/adminapi/privilegeConfig/del",
            method: "POST",
            body: JSON.stringify({ ...params }),
          })
            .then((res) => {
              if (res.body.error === 10000) {
                this.queryList();
              } else {
                this.$util.errorMsg(res.body.message || "请联系管理员");
              }
            })
            .catch((err) => {
              this.$util.errorMsg(err.message);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    // 点击重置
    clickReset() {
      this.paramData = {
        status: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.queryList();
    },
    // 点击新增
    clickAddition() {
      this.$router.push({
        path: "/yunying/user/member/sale/detail",
        query: { actionType: "add" },
      });
    },
    // 点击编辑
    clickEdit(row) {
      this.$util.setStore("member-sale-list-item", row);
      this.$router.push({
        path: "/yunying/user/member/sale/detail",
        query: { actionType: "edit" },
      });
    },
    routeMemberPromotion(row) {
      this.$router.push({
        path: "/yunying/user/member/promotion",
        query: { id: row.id },
      });
    },
    // 点击发布
    clickPublish(row) {
      const params = {
        id: row.id,
        status: 1,
      };
      this.updateStatus(params);
    },
    // 点击撤销
    clickRevoke(row) {
      const params = {
        id: row.id,
        status: 2,
      };
      this.updateStatus(params);
    },
    // 点击删除
    clickDelete(row) {
      const params = {
        id: row.id,
      };
      this.sendDelete(params);
    },
    // 切换当前页码
    changeCurrentPage(value) {
      this.paramData.pageNum = value;
      this.queryList();
    },
    // 切换 售卖卡 / 赠送卡 / 预售卡
    handleTabChange(type) {
      const next = String(type);
      if (this.activeTab === next) {
        return;
      }
      this.activeTab = next;
      this.paramData.pageNum = 1;
      this.queryList();
    },
    // 点击「导出卡销售明细」
    clickExport() {
      this.exportForm = {
        timeRange: [],
        status: 1,
        types: [1, 3],
        privilegeConfigIds: [],
      };
      this.sellOptions = [];
      this.exportDialog.visible = true;
      this.fetchSellOptions();
    },
    // 会员卡状态变化：重新拉取会员卡选项，并剔除不在新范围内的已选项
    handleExportStatusChange() {
      this.fetchSellOptions();
    },
    // 会员卡类型变化：同上
    handleExportTypeChange() {
      this.fetchSellOptions();
    },
    // 按当前选中的会员卡状态 + 类型查询会员卡选项（statuses/type 均为重复 query 参数）
    fetchSellOptions() {
      const status = this.exportForm.status;
      const types = this.exportForm.types || [];
      const query = [];
      if (status) {
        query.push(`statuses=${status}`);
      }
      types.forEach((t) => query.push(`type=${t}`));
      const url =
        this.$util.domain +
        "/adminapi/privilegeConfig/sellOptions" +
        (query.length ? `?${query.join("&")}` : "");
      this.$http({ url, method: "GET" })
        .then((res) => {
          const body = res.data || res.body || {};
          if (body.error === 10000 || body.error === 0) {
            const list = body.data || [];
            this.sellOptions = list;
            const validIds = list.map((c) => c.id);
            this.exportForm.privilegeConfigIds = (
              this.exportForm.privilegeConfigIds || []
            ).filter((id) => validIds.indexOf(id) > -1);
          } else {
            this.sellOptions = [];
          }
        })
        .catch(() => {
          this.sellOptions = [];
        });
    },
    // 导出时间格式化（yyyy-MM-dd HH:mm:ss）
    formatExportTime(value) {
      const date = new Date(value);
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },
    // 导出表单校验
    validateExport() {
      const range = this.exportForm.timeRange || [];
      if (range.length !== 2 || !range[0] || !range[1]) {
        this.$util.errorMsg("请选择销售时间");
        return false;
      }
      const start = new Date(range[0]).getTime();
      const end = new Date(range[1]).getTime();
      if (isNaN(start) || isNaN(end)) {
        this.$util.errorMsg("销售时间格式不正确");
        return false;
      }
      if (start >= end) {
        this.$util.errorMsg("开始时间须早于结束时间");
        return false;
      }
      if (end > Date.now()) {
        this.$util.errorMsg("结束时间须早于或等于当前系统时间");
        return false;
      }
      if (end - start > 365 * 24 * 60 * 60 * 1000) {
        this.$util.errorMsg("开始时间至结束时间跨度最多365天");
        return false;
      }
      return true;
    },
    // 确认导出：POST /adminapi/privilegeConfig/exportSales（返回文件流）
    async confirmExport() {
      if (!this.validateExport()) return;
      const startTime = dayjs(this.exportForm.timeRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      const endTime = dayjs(this.exportForm.timeRange[1])
        .add(24 * 60 * 60 - 1, "s")
        .format("YYYY-MM-DD HH:mm:ss");
      const payload = {
        startTime,
        endTime,
        statuses: this.exportForm.status ? [this.exportForm.status] : [],
        // 类型多选：1售卖卡 3预售卡
        type: [...(this.exportForm.types || [])],
        privilegeConfigIds: [...this.exportForm.privilegeConfigIds],
      };
      this.exportDialog.loading = true;
      try {
        const res = await fetch(
          this.$util.domain + "/adminapi/privilegeConfig/exportSales",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            credentials: "include",
          }
        );
        if (!res.ok) throw new Error("export request failed");
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `会员卡销售明细_${startTime.substring(
          0,
          11
        )}-${endTime.substring(0, 11)}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
        this.$util.successMsg("导出成功");
        this.exportDialog.visible = false;
      } catch (err) {
        this.$util.errorMsg("导出失败");
      } finally {
        this.exportDialog.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card-type-group {
  margin-right: auto;
}

.tip-text {
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// MemberSale.vue?6bbf0cb1